"use client"

import { useState, useEffect } from "react"
import { formatTableReports, getOrDeleteRequest, getSession } from "../../../utils/utils"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom"
import MainThemeLayout from "../../../layout/MainThemeLayout"
import DataTableComponent from "../../../components/DataTableComponent"
import SelectMultiple from "../../../components/SelectMultiple"
import exportFromJSON from "export-from-json"

const Reports = () => {
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState([])
  const [projects, setProjects] = useState([])
  const [companies, setCompanies] = useState([])
  const [idProject, setIdProject] = useState(null)
  const [idCompany, setIdCompany] = useState(null)
  const session = getSession()

  const getReports = async (page = 1, company_id = null) => {
    setLoading(true)
    setData([])
    let uri;

    if ([1, 6].includes(session.type_id)) {
      uri = `reports/list-report/admin/${session.id}?page=${page}&project_id=${idProject}${company_id ? `&company_id=${company_id}` : ""}`
    }

    if ([4, 5].includes(session.type_id)) {
      uri = `reports/list-report/admin/${session.type_id === 4 ? session.id : session.company.user_id}?page=${page}&project_id=${idProject}&company_id=${session.company.id}`
    }

    if (typeof idCompany === "number" && idCompany === null) {
      uri += `&company_id=` + idCompany;
    }

    const response = await getOrDeleteRequest(uri, "GET")

    if (response.type === "success") {
      setData(response.data)
    } else {
      setData([])
    }
    setLoading(false)
  }

  const getProjects = async () => {
    const session = getSession()

    let uri

    if ([1, 6].includes(session.type_id)) {
      uri = `projects/filter`
    }

    if ([4, 5].includes(session.type_id)) {
      uri = `projects/projectbycompany/${session.company.id}`
    }

    const response = await getOrDeleteRequest(uri, "GET")

    if (response.type === "success") {
      setProjects(response.data)
    }
  }

  const getCompanies = async (e) => {
    const response = await getOrDeleteRequest(`company/filter?project_id=${e}`, "GET")

    if (response.type === "success") {
      setCompanies(
        response.data.length > 0
          ? response.data.map((item) => {
              return {
                id: item.id,
                name: `${item.company_name} ${item.trade_name ? `(${item.trade_name})` : ""}`,
              }
            })
          : [],
      )
    }
  }

  const columns = [
    {
      name: "Fecha reportada",
      selector: (row) => row.report_created_date,
    },
    {
      name: "Empresa o entidad",
      selector: (row) => `${row?.company?.company_name}`,
    },
    {
      name: "Razón social",
      selector: (row) => row?.company?.trade_name,
    },
    {
      name: "Dirección",
      selector: (row) => row?.company?.address,
    },
    {
      name: "Nombre de persona de contacto",
      selector: (row) => row?.company?.contact_name ?? "Sin nombre de contacto",
    },
    {
      name: "Número de contacto",
      selector: (row) => row?.company?.contact_phone ?? "Sin número de contacto",
    },
    {
      name: "Fecha de creación",
      width: "350px",
      selector: (row) => formatTableReports(row.created_at),
    },
    {
      name: "Fecha de actualización",
      width: "350px",
      selector: (row) => (row.updated_at ? formatTableReports(row.updated_at) : "Sin fecha de actualización"),
    },
  ]

  const allFunctions = async () => {
    setLoading(true)
    await getProjects()
    setLoading(false)
  }

  useEffect(() => {
    allFunctions()
  }, [])

  useEffect(() => {
    if (idProject) {
      setIdCompany(null)
      setCompanies([])

      if ([4, 5].includes(session.type_id)) {
        getReports(1)
      }

      if ([1, 6].includes(session.type_id)) {
        getCompanies(idProject)
      }
    } else {
      setData([])
      setCompanies([])
      setIdCompany(null)
    }
  }, [idProject])

  useEffect(() => {
    if (idProject) {
      if (idCompany) {
        getReports(1, idCompany)
      } else if ([1, 6].includes(session.type_id)) {
        setData([])
      } else {
        getReports(1)
      }
    }
  }, [idCompany])

  const exportToExcelReports = async () => {
    const response = await getOrDeleteRequest(
      `reports/admin/list-report-all-company-csv/${session?.type_id === 4 ? session?.company?.user_id : idCompany}?project_id=${idProject}`,
      "GET",
    )
    const company = companies.find((c) => c.id === idCompany)

    if (response.type === "success" && response.responses && typeof response.responses === "object") {
      const allQuestions = new Set()
      const dataByDate = {}

      Object.entries(response.responses).forEach(([date, items]) => {
        items.forEach((item) => {
          allQuestions.add(item.question)
        })
      })

      const questionsArray = Array.from(allQuestions).sort()

      Object.entries(response.responses).forEach(([date, items]) => {
        const dateData = { Fecha: date }

        questionsArray.forEach((question) => {
          dateData[question] = ""
        })

        items.forEach((item) => {
          dateData[item.question] = item.response
        })

        dataByDate[date] = dateData
      })

      const dataToExport = Object.values(dataByDate)
      dataToExport.forEach((item) => {
        Object.keys(item).forEach((key) => {
          const newKey = `"${key}"`
          if (newKey !== key) {
            item[newKey] = item[key]
            delete item[key]
          }
        })
      })

      const fileName = `ConsolidadoDeReportes_${
        session.type_id === 4
          ? `${session?.company?.company_name} ${session?.company?.trade_name ? ` (${session.company.trade_name})` : ""}`
          : company?.name
      }`
      const exportType = "csv"

      exportFromJSON({ data: dataToExport, fileName, exportType, withBOM: true })
    } else {
      console.error("Respuesta no válida o sin datos.")
    }
  }

  return (
    <MainThemeLayout>
      <div className="px-8 py-6">
        <div className="mb-4">
          <div className="flex items-center justify-between">
            <h1 className="text-xl font-semibold text-stone-800 dark:text-white mb-2">Reportes</h1>
            <Link to="/PapeleraReportes" className="text-xs flex items-center hover:text-red-900"><FontAwesomeIcon icon={faTrash} /> <span className="text-sm px-1">Papelera</span></Link>
          </div>
          <p className="text-sm text-stone-500 dark:text-white">Listado de reportes registrados en la plataforma.</p>
          <div className="w-full mt-4">
            <SelectMultiple
              name="projects"
              loading={loading}
              array={projects}
              label="Reportes por proyecto"
              isMulti={false}
              value={idProject}
              onChange={(e) => {
                setIdProject(e)
              }}
              placeholder="Seleccione un proyecto"
            />
          </div>
          {idProject && [1, 6].includes(getSession().type_id) && (
            <div className="w-full mt-4">
              <SelectMultiple
                name="company_id"
                loading={loading}
                array={companies}
                label="Reportes por empresa o entidad"
                isMulti={false}
                value={idCompany}
                onChange={(e) => {
                  if (e) {
                    setIdCompany(e)
                  } else {
                    getReports(1)
                  }
                }}
                placeholder="Seleccione una empresa o entidad"
              />
            </div>
          )}
          {(([1, 6].includes(session.type_id) && idCompany && idProject) || (session.type_id === 4 && idProject)) && (
            <div className="w-full mt-4">
              <button
                onClick={exportToExcelReports}
                className="bg-turquesa hover:opacity-90 rounded-lg px-4 py-2 text-sm text-white cursor-pointer"
              >
                Exportar consolidado de reportes en CSV
              </button>
            </div>
          )}
        </div>
        {idProject && (
          <div>
            <DataTableComponent
              nameTable={"Reportes"}
              data={data}
              columns={columns}
              setLoading={setLoading}
              loading={loading}
              toViewReport="/VerReporte/"
              toEditReport="/EditarReporte/"
              toDelete="response/destroy/"
              toExportReport={"reports/admin/list-report-company-csv/"}
              reload={getReports}
              button={
                ![1, 6].includes(getSession().type_id) && (
                  <Link
                    to={"/AgregarReporte"}
                    className="bg-turquesa hover:opacity-90 rounded-lg px-4 py-2 text-sm text-white cursor-pointer"
                  >
                    Agregar
                  </Link>
                )
              }
            />
          </div>
        )}
      </div>
    </MainThemeLayout>
  )
}

export default Reports
